import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';

const API = process.env.REACT_APP_API_URL;
const SLUG = 'borewell-cleaning';
// Fixed slots: img[0]=before, img[1]=after, img[2]=process strip
// Additional: img[3+]

const BorewellCleaning = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/services/${SLUG}`)
      .then((r) => r.json())
      .then((d) => { if (d.success) setData(d.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="sp-loading"><div className="sp-spinner" /><p>Loading...</p></div>;
  if (!data) return null;

  const imgs = data.images || [];
  const heroStyle = data.bannerUrl ? { backgroundImage: `url(${data.bannerUrl})` } : {};
  const heroClass = `service-hero${data.bannerUrl ? '' : ' service-hero-gradient'}`;

  // Show before/after section only when at least one image exists
  const hasBeforeAfter = imgs[0] || imgs[1];

  return (
    <div className="service-page">
      <div className={heroClass} style={heroStyle}>
        <div className="service-hero-content">
          {!data.bannerUrl && <div className="service-hero-icon">{data.icon}</div>}
          <h1>{data.title}</h1>
          <p>{data.subtitle}</p>
        </div>
      </div>

      <div className="bc-body">
        <div className="breadcrumb">
          <Link to="/">Home</Link> &rsaquo; <Link to="/">Services</Link> &rsaquo; <span>{data.title}</span>
        </div>

        <div className="bc-intro">
          <p>{data.intro}</p>
          <p>{data.intro2}</p>
        </div>

        {/* Before/After pair — only if at least one image uploaded */}
        {hasBeforeAfter && (
          <div className="bc-before-after">
            <div className="bc-ba-pair">
              {imgs[0] && (
                <div className="bc-ba-card">
                  <img src={imgs[0].url} alt="Before" />
                  <div className="bc-ba-label">Before</div>
                  <div className="bc-ba-caption">{imgs[0].caption || 'Before cleaning'}</div>
                </div>
              )}
              {imgs[1] && (
                <div className="bc-ba-card">
                  <img src={imgs[1].url} alt="After" />
                  <div className="bc-ba-label">After</div>
                  <div className="bc-ba-caption">{imgs[1].caption || 'After cleaning'}</div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Process strip — only if uploaded */}
        {imgs[2] && (
          <div className="bc-process-strip">
            <img src={imgs[2].url} alt={imgs[2].caption || data.title} />
          </div>
        )}

        {data.processSteps && data.processSteps.length > 0 && (
          <div className="bc-steps">
            <h2>{data.processTitle}</h2>
            <div className="bc-step-bar">
              {data.processSteps.map((s) => (
                <div className="bc-step" key={s.step}>
                  <div className="bc-step-circle">{s.step}</div>
                  <h4>{s.title}</h4>
                  <p>{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {data.features && data.features.length > 0 && (
          <div className="bc-feats-section">
            <h2>{data.featuresTitle}</h2>
            <div className="bc-feats">
              {data.features.map((f) => (
                <div className="bc-feat" key={f.title}>
                  <div className="bc-feat-icon">{f.icon}</div>
                  <h4>{f.title}</h4>
                  <p>{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {data.specs && data.specs.length > 0 && (
          <div className="bc-specs">
            <h2>{data.specsTitle}</h2>
            <table><tbody>
              {data.specs.map((row, i) => <tr key={i}><td>{row[0]}</td><td>{row[1]}</td></tr>)}
            </tbody></table>
          </div>
        )}

        {imgs.length > 3 && (
          <div className="sp-additional-images">
            <h3>Additional Service Images</h3>
            <div className="sp-additional-grid">
              {imgs.slice(3).map((img) => (
                <div className="sp-additional-card" key={img.filename}>
                  <img src={img.url} alt={img.caption || data.title} />
                  {img.caption && <p>{img.caption}</p>}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="sp-cta">
          <h2>{data.ctaTitle}</h2>
          <p>{data.ctaText}</p>
          <a href="/#contact" className="sp-cta-btn">Get a Free Quote</a>
        </div>
      </div>
    </div>
  );
};

export default BorewellCleaning;
